<div *ngIf="myControl && myControl.dirty">
  <small class="help-block text-danger" *ngFor="let item of changeToArray(myControl)"> {{item.value | translate}}</small>
</div>
